import "./SolarEnergyTechnician.module.css";
import Header from "@/reusable_sections/Header";
import SobreCiteling from "./sections/SobreCiteling";
import ModulosDelCurso from "./sections/ModulosDelCurso";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function SolarEnergyTechnicianPage() {
  return <div>
      <Header />
      <SobreCiteling />
      <ModulosDelCurso />
      <CallToAction />
      <Footer />
    </div>;
}